import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import axios from "axios";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import { globalConfig } from "../../../config/config";
// import { useContentObjectContext } from "../contexts/ContentObjectContext";

const CreateContentType = () => {
  const [contentTypes, setContentTypes] = useState([]);
  const { currentContentObject } = 0; //useContentObjectContext();

	const token = globalConfig.hardcoded_header;
  const [message, setMessage] = useState("");
  const [state, setState] = useState({
    contentTypeId: 0,
    contentId: currentContentObject,
    contentTypeValueCode: 0,
    contentTypeName: "",
    contentTypeDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value) ? target.value : parseInt(target.value),
    });

    console.log(state);
  }
  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-types`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-types/contentTypeId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentTypeId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(response2.status + ":" + response2.data.contentTypeId);
          // && response2.data.contentFacadeId === this.state.contentFacadeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      console.log("message info - " + message);
      setState({ ...state, contentTypeName: "", contentTypeDescr: "" });
    });

    // console.log("SetState Message info-" + this.contentFacadeTypeId);
    // console.log("SetState Message info-" + this.contentFacadeName);
  }
  function handleRest() {
    setState({ ...state, contentTypeName: "", contentTypeDescr: "" });
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_TYPE`,
         apiHeader(token)
      )
      .then((res) => {
        const contentTypes = res.data;
        console.log(contentTypes);
        setContentTypes(contentTypes);
      })
      .catch((x) => {
      });
  };

  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Type</h4>			
			<Link to="/breeze/list-content-types">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            readOnly={true}
            id="contentId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Content Type Name</label>
          <input
            id="contentTypeName"
            className="form-control input-medium col-sm-8"
            value={state.contentTypeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Content Type Code</label>
          <select
            className="form-control input-xlarge col-sm-8"
            id="contentTypeValueCode"
            value={state.contentTypeValueCode}
            onChange={handleChange}
          >
            {/* <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('CONTENT_TYPE')}" /> */}

            <option value={0}>Select Content Type</option>
            {contentTypes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">
            Content Type Description
          </label>
          <textarea
            id="contentTypeDescr"
            className="form-control input-big col-sm-8"
            value={state.contentTypeDescr}
            onChange={handleChange}
          />
        </div>
        <hr />
        <button className="btn btn-primary" value="Clear" onClick={handleRest}>
          Clear
        </button>{" "}
        &nbsp;
        <button
          className="btn btn-success"
          value="Create"
          onClick={handleSubmit}
        >
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentType;
